<template>
  <div class="ProductTabs Pt75">
    <div class="box">
      <div class="PubTitle center">
        <h2>优质除湿机产品 · 多种选择满足需求</h2>
      </div>

      <div v-if="loading" class="loading-state">正在加载产品...</div>
      <div v-if="error" class="error-state">数据加载失败: {{ error }}</div>

      <template v-if="!loading && !error && productCategories.length > 0">
        <div class="Click">
          <div class="flex">
            <p
                v-for="(category, index) in productCategories"
                :key="category.id"
                :class="{ Active: activeTab === index }"
                @click="setActiveTab(index)"
            >
              {{ category.name }}
            </p>
          </div>
        </div>
        <div class="ClickShow">
          <div
              v-for="(category, index) in productCategories"
              :key="category.id"
              class="One"
              :class="{ Active: activeTab === index }"
          >
            <div class="product-grid">
              <div v-for="product in category.products" :key="product.id" class="product-card">
                <div class="card-image">
                  <img :src="product.image" :alt="product.name"/>
                  <div class="image-overlay">
                    <router-link :to="product.to" class="details-link">查看详情 →</router-link>
                  </div>
                </div>
                <div class="card-content">
                  <h3>{{ product.name }}</h3>
                  <ul class="subcategory-list">
                    <li v-for="(value, key) in product.dehumidification" :key="key">{{ key }}: {{ value }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// 新增: 导入 API 请求函数
import { getProductsCategory, getProductList } from '@/api/request.js';

export default {
  name: 'ProductTabs',
  data() {
    return {
      activeTab: 0,
      productCategories: [], // 新增: 用于存储从API获取的分类和产品数据
      loading: true,         // 新增: 加载状态
      error: null,           // 新增: 错误信息
    };
  },
  async mounted() {
    // 新增: 组件挂载后执行数据获取
    await this.fetchProductData();
  },
  methods: {
    // 修改: setActiveTab 方法简化
    setActiveTab(index) {
      this.activeTab = index;
    },
    // 新增: 核心数据获取方法
    async fetchProductData() {
      this.loading = true;
      this.error = null;
      try {
        // 步骤 1: 根据 parent_id=2 获取产品分类
        const categoryResponse = await getProductsCategory({ parent_id: 1});
        let categories = (categoryResponse?.list || []).sort((a, b) => a.sort_order - b.sort_order);

        if (categories.length === 0) {
          console.warn("未找到任何有效的产品分类。");
          this.loading = false;
          return;
        }

        // 步骤 2: 并发获取每个分类下的产品列表 (此处示例为获取前5个)
        const productPromises = categories.map(category =>
            getProductList({
              category_id: category.id
            })
        );
        const productResponses = await Promise.all(productPromises);

        // 步骤 3: 将分类和其对应的产品数据整合到 productCategories
        this.productCategories = categories.map((category, index) => {
          const productData = productResponses[index];
          const products = (productData?.list || []).map(p => ({
            id: p.id,
            name: p.name,
            dehumidification: p.technical_parameters,
            coverage: p.technical_parameters?.['适用面积'] ? `适用面积: ${p.technical_parameters['适用面积']}` : '适用面积:222',
            image: p.cover_image_url, // 注意: 可能需要拼接基础URL
            to: `/product_list/${category.id}?productId=${p.id}`
          }));

          return {
            id: category.id,
            name: category.name,
            products: products
          };
        });

      } catch (err) {
        console.error('获取产品数据失败:', err);
        this.error = err.message || '未知错误';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* 样式部分保持不变 */
.ProductTabs {
  padding-top: 75px;
}

.PubTitle.center h2 {
  font-size: 2em;
  text-align: center;
  margin-bottom: 30px;
}

/* 新增: 加载和错误状态的简单样式 */
.loading-state, .error-state {
  text-align: center;
  padding: 40px;
  font-size: 1.2em;
  color: #666;
}
.error-state {
  color: #d9534f;
}

.flex {
  display: flex;
}

.Click {
  width: 100%;
  margin-bottom: 20px;
}

.Click .flex {
  justify-content: center;
  gap: 20px;
}

.Click p {
  padding: 10px 20px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  font-size: 1.1em;
}

.Click p.Active {
  border-bottom: 2px solid #47975a;
  font-weight: bold;
  color: #47975a;
}

.ClickShow {
  width: 100%;
}

.One {
  display: none;
}

.One.Active {
  display: block;
}

/* 产品网格样式 - 参考 ProductPage.vue */
.product-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
}

.product-card {
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  flex: 0 0 calc(33.333% - 27px);
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

/* 卡片图片样式 - 参考 ProductPage.vue */
.card-image {
  position: relative;
  height: 300px;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 20px;
  background-color: #f8f9fa;
  transition: transform 0.3s ease;
}

.product-card:hover .card-image img {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.product-card:hover .image-overlay {
  opacity: 1;
}

.details-link {
  color: #fff;
  background-color: rgba(71, 151, 90, 0.8);
  padding: 12px 24px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.details-link:hover {
  background-color: #47975a;
}

/* 卡片内容样式 - 参考 ProductPage.vue */
.card-content {
  padding: 25px 30px;
  text-align: center;
  flex-grow: 1;
}

.card-content h3 {
  font-size: 24px;
  font-weight: 600;
  color: #47975a;
  margin-bottom: 20px;
}

/* 添加与ProductPage.vue中相同的子类别列表样式 */
.subcategory-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.subcategory-list li {
  background-color: #f0f8f4;
  color: #47975a;
  padding: 6px 15px;
  border-radius: 15px;
  font-size: 14px;
  font-weight: 500;
}

@media (max-width: 768px) {
  .Click .flex {
    flex-direction: column;
    align-items: center;
  }

  .card-image {
    height: 200px;
  }

  .Click p {
    width: 100%;
    text-align: center;
  }

  .product-card {
    flex: 0 0 calc(50% - 20px);
  }
  
  .parameter-key {
    min-width: 100px;
  }
}

@media (max-width: 480px) {
  .product-card {
    flex: 0 0 100%;
  }
  
  .parameter-item {
    flex-direction: column;
  }
  
  .parameter-key {
    min-width: unset;
    margin-bottom: 2px;
  }
  
  .card-content {
    padding: 10px;
  }
  
  .card-content h3 {
    font-size: 20px;
  }
  
  .subcategory-list li {
    font-size: 13px;
    padding: 5px 8px;
  }
}
</style>